const template=`
<widget-status></widget-status>
<div>
  <h3 class="widgetNoResultsLabel translate" ng-show="noContent &amp;&amp; !widgetIsLoading">No results</h3>
</div>
<momentum-d3 class="bubble" data="chartData" selected="selectedNodes" data-ng-hide="widgetIsLoading || noContent"></momentum-d3>`;
export default template;
